import { generateURL } from 'utils/helpers';

const assets = {
  getVimeoThumbnailById: (id) => {
    const url = generateURL(`/assets/vimeo_thumbnail/${id}`);
    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to get resource'));
      }
      return response.text();
    });
  },
};

export default assets;
